import styled from 'styled-components'

export const Body = styled.div`
  height: 100%;
`
